module.exports = __webpack_public_path__ + "img/green_101.eb315aed.png";